import { z } from 'zod';

export type OnboardingEventType =
  | 'Onboarding_WelcomeCTAClicked'
  | 'Onboarding_WelcomeOptOutClicked'
  | 'Onboarding_Home_OtherProductsCreateProductClicked'
  | 'Onboarding_Home_ChecklistItemClicked'
  | 'Onboarding_Home_ChecklistCompleteSubmitProductClicked'
  | 'Onboarding_Home_ActiveProductCardCreateFirstProductClicked';

// Onboarding event payload schemas
export const OnboardingEventBaseSchema = z.object({
  source: z.string(),
  eventContext: z.string().optional(),
  feature: z.string(),
  feature_version: z.string(),
  page: z.string(),
});

export const Onboarding_WelcomeCTAClickedPayloadSchema = OnboardingEventBaseSchema.extend({});

export const Onboarding_WelcomeOptOutClickedPayloadSchema = OnboardingEventBaseSchema.extend({});

export const Onboarding_Home_OtherProductsCreateProductClickedPayloadSchema = OnboardingEventBaseSchema.extend({});

export const Onboarding_Home_ChecklistItemClickedPayloadSchema = OnboardingEventBaseSchema.extend({
  checklistItemKey: z.string(),
});

export const Onboarding_Home_ChecklistCompleteSubmitProductClickedPayloadSchema = OnboardingEventBaseSchema.extend({});

export const Onboarding_Home_ActiveProductCardCreateFirstProductClickedPayloadSchema = OnboardingEventBaseSchema.extend(
  {}
);

export type OnboardingEventTypePayloadMap = {
  Onboarding_WelcomeCTAClicked: z.infer<typeof Onboarding_WelcomeCTAClickedPayloadSchema>;
  Onboarding_WelcomeOptOutClicked: z.infer<typeof Onboarding_WelcomeOptOutClickedPayloadSchema>;
  Onboarding_Home_OtherProductsCreateProductClicked: z.infer<
    typeof Onboarding_Home_OtherProductsCreateProductClickedPayloadSchema
  >;
  Onboarding_Home_ChecklistItemClicked: z.infer<typeof Onboarding_Home_ChecklistItemClickedPayloadSchema>;
  Onboarding_Home_ChecklistCompleteSubmitProductClicked: z.infer<
    typeof Onboarding_Home_ChecklistCompleteSubmitProductClickedPayloadSchema
  >;
  Onboarding_Home_ActiveProductCardCreateFirstProductClicked: z.infer<
    typeof Onboarding_Home_ActiveProductCardCreateFirstProductClickedPayloadSchema
  >;
};

export const OnboardingEventSchemaMap = {
  Onboarding_WelcomeCTAClicked: Onboarding_WelcomeCTAClickedPayloadSchema,
  Onboarding_WelcomeOptOutClicked: Onboarding_WelcomeOptOutClickedPayloadSchema,
  Onboarding_Home_OtherProductsCreateProductClicked: Onboarding_Home_OtherProductsCreateProductClickedPayloadSchema,
  Onboarding_Home_ChecklistItemClicked: Onboarding_Home_ChecklistItemClickedPayloadSchema,
  Onboarding_Home_ChecklistCompleteSubmitProductClicked:
    Onboarding_Home_ChecklistCompleteSubmitProductClickedPayloadSchema,
  Onboarding_Home_ActiveProductCardCreateFirstProductClicked:
    Onboarding_Home_ActiveProductCardCreateFirstProductClickedPayloadSchema,
};
